import { render, staticRenderFns } from "./OverageAccount.vue?vue&type=template&id=4f8e5b66&"
import script from "./OverageAccount.vue?vue&type=script&lang=js&"
export * from "./OverageAccount.vue?vue&type=script&lang=js&"
import style0 from "./OverageAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports